import { createConnectQuery } from '@jotta/grpc-connect-client/createConnectQuery'
import { getOffers } from '@jotta/grpc-connect-openapi/offerQuery'

export const useGetOffers = createConnectQuery(getOffers)
